import { useTranslation } from 'react-i18next';
import { InfoCircleIcon } from '@c2fo/liquidity/icons';
import { useReporting } from '@/reporting';
import KpiSpotlightBannerShell from './KpiSpotlightBannerShell';

const appDomain = (import.meta.env.VITE_LOGIN_URL ?? '').replace('/login', '');

/**
 * The original static FinanceIQ promo banner. Used whenever the spotlight endpoint has nothing
 * KPI-worthy to show for this buyer (`spotlight: null`) or fails to load — the API contract calls
 * this out explicitly as the fallback for the null case, and it doubles as the QueryBoundaries
 * ErrorComponent so a failed fetch degrades to the same promo rather than an empty gap. Uses the
 * same KpiSpotlightBannerShell as every KPI card (lightBlue — matches Liquidity's own `info` tone)
 * so this state looks consistent with the rest, not like a different component.
 */
const FinanceIqFallbackAlert = () => {
  const { t } = useTranslation();
  const { trackEnterpriseEvent } = useReporting();

  return (
    <KpiSpotlightBannerShell
      containerClassName="border-lightBlue-500 bg-lightBlue-50"
      accentClassName="bg-lightBlue-500"
      textClassName="text-lightBlue-900"
      icon={InfoCircleIcon}
      iconClassName="fill-lightBlue-500"
      title={t('invoiceCentral.financeIq.title')}
      description={<span>{t('invoiceCentral.financeIq.description')}</span>}
      action={{
        text: t('invoiceCentral.financeIq.action'),
        onClick: () => {
          trackEnterpriseEvent('invoice-central::finance-iq-navigation::clicked');
          window.open(
            `${appDomain}/financeiq/?utm_partner=&utm_lang=en_US&utm_source=c2fo&utm_medium=in_app&utm_region=amer&utm_lifecycle=cross&utm_audience=na&utm_campaign=financeiq&utm_series=invoicecentral426&utm_country=us&utm_content=&utm_term=`,
            '_blank',
            'noreferrer'
          );
        },
      }}
    />
  );
};

export default FinanceIqFallbackAlert;
